import { render, staticRenderFns } from "./WalletTransfer.vue?vue&type=template&id=36bac0d5"
import script from "./WalletTransfer.vue?vue&type=script&lang=js"
export * from "./WalletTransfer.vue?vue&type=script&lang=js"
import style0 from "./WalletTransfer.vue?vue&type=style&index=0&id=36bac0d5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports